const styles = () => ({
  root: {
    minHeight: 70,
    justifyContent: 'space-between',
    borderBottom: '1px solid rgba(50, 50, 50, 1)',
  },
  title: {
    maxWidth: '20%',
    fontSize: '1rem',
  },
})

export default styles
